import React, { useEffect, useRef, useState } from "react";
import "./providerSelect.css";
import { IStoreProvider } from "../../../store/models/slots/typing/slot.interface";
import { Box, Container, Dialog, InputBase, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useMediaQuery } from "react-responsive";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/store.hooks";
import { getProviders } from "../../../store/models/slots/slot.thunk";
import { ProviderSelector } from "../../ProvidersSection/provider.selector";

type IProviderSelectProps = {
  section: "main" | "slots" | "live" | "crash";
  onClick: (providerId: number) => void;
};

export const ProviderSelect = ({ section, onClick }: IProviderSelectProps) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const isMobile = useMediaQuery({ maxWidth: 599.98 });
  const dispatch = useAppDispatch();
  const [active, setActive] = useState(false);
  const { providers } = useAppSelector(ProviderSelector(section));
  // const [providers, setProviders] = useState<IStoreProvider[]>([]);
  const [copy, setCopy] = useState<
    {
      id: number;
      firstLetter: string;
      providers: IStoreProvider[];
    }[]
  >([]);
  const { t } = useTranslation();
  const [input, setInput] = useState("");
  const openHandler = () => {
    setActive(true);
  };
  const closeHandler = () => {
    setActive(false);
  };
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setCopy((prev) => {
      return prev.filter((item) => {
        return (
          item.providers.filter((provider) => {
            return provider.name
              .toLowerCase()
              .trim()
              .includes(input.toLocaleLowerCase().trim());
          }).length > 0
        );
      });
    });
  };
  const inputHandler = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setInput(e.target.value);
    if (e.target.value === "") {
      setCopy(copyHandler(providers));
    }
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (input.trim()) {
        setCopy((prev) => {
          return prev.filter((item) => {
            return (
              item.providers.filter((provider) => {
                return provider.name
                  .toLowerCase()
                  .trim()
                  .includes(input.toLocaleLowerCase().trim());
              }).length > 0
            );
          });
        });
      }
    }, 700);

    return () => clearTimeout(delayDebounceFn);
  }, [input]);
  useEffect(() => {
    if (providers.length === 0) {
      dispatch(getProviders({ section }));
    }
  }, []);
  console.log("first");
  useEffect(() => {
    setCopy(copyHandler(providers));
  }, [providers.length]);
  const getPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight; // Висота вікна браузера
      const spaceBelow = windowHeight - rect.bottom; // Простір під кнопкою
      const showAbove = spaceBelow < 404 + 24;
      return {
        top: showAbove ? 96 : rect.bottom + 12,
        left: rect.right,
      };
    }
    return { top: 0, left: 0 };
  };
  const position = getPosition();
  return (
    <>
      <Box className="provider-select">
        <button
          className="provider-select__button"
          onClick={openHandler}
          ref={buttonRef}
        >
          {t("slots.providers")}
        </button>
      </Box>

      <Dialog
        open={active}
        onClose={closeHandler}
        slotProps={{
          backdrop: {
            sx: { backgroundColor: "transparent" },
          },
        }}
      >
        <Box
          className={`provider-select__portal ${active ? "active" : ""}`}
          onClick={closeHandler}
        >
          <Container
            className="container"
            maxWidth={false}
            disableGutters
            sx={{ height: "100%" }}
          >
            <Box
              className={`provider-select__container`}
              onClick={(e) => {
                e.stopPropagation();
              }}
              sx={{
                top: `${position.top}px`,
                left: `${position.left}px`,
              }}
            >
              {isMobile && (
                <Box className="provider-select__title__container">
                  <h1 className="provider-select__title">
                    {t("slots.providers")}
                  </h1>
                  <CloseIcon
                    onClick={closeHandler}
                    className="provider-select__title__icon"
                    sx={{ fontSize: "16px" }}
                  />
                </Box>
              )}
              <Box className="provider-select__input-container">
                <Paper
                  className="provider-select__input-form"
                  component="form"
                  onSubmit={onSubmit}
                >
                  <SearchIcon
                    sx={{
                      height: "20px",
                      position: "absolute",
                      top: "8px",
                      left: "12px",
                      zIndex: 1,
                    }}
                  />

                  <InputBase
                    sx={{
                      width: "100%",
                      flex: 1,
                    }}
                    placeholder={t("slots.input_label")}
                    inputProps={{
                      className: "provider-select__input",
                      "aria-label": t("slots.input_label"),
                    }}
                    value={input}
                    onChange={inputHandler}
                  />
                </Paper>
              </Box>
              <Box className="provider-select__list">
                {copy
                  .sort((a, b) => {
                    // Якщо одна з літер - цифра, вона має йти першою
                    if (/\d/.test(a.firstLetter) && !/\d/.test(b.firstLetter)) {
                      return -1;
                    }
                    if (!/\d/.test(a.firstLetter) && /\d/.test(b.firstLetter)) {
                      return 1;
                    }

                    // Якщо обидві літери або не цифри, або цифри, сортуємо за алфавітом
                    return a.firstLetter.localeCompare(b.firstLetter);
                  })
                  .map((provider) => {
                    return (
                      <Box
                        key={provider.id}
                        className="provider-select__list-container"
                      >
                        <Box className="provider-select__list-title">
                          {provider.firstLetter}
                        </Box>
                        <Box className="provider-select__list-providers">
                          {provider.providers.map((providerItem) => {
                            return (
                              <Box
                                className="provider-select__list-provider-name"
                                key={providerItem.id}
                                onClick={() => {
                                  onClick(providerItem.id);
                                  closeHandler();
                                }}
                              >
                                {providerItem.name}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </>
  );
};

const copyHandler = (data: IStoreProvider[]) => {
  const firstLettersArray: {
    id: number;
    firstLetter: string;
    providers: IStoreProvider[];
  }[] = [];
  let i = 0;
  const reg = /^\d+$/;
  data.forEach((provider) => {
    const firstLetter = provider.name.slice(0, 1);
    const index = firstLettersArray.findIndex((item) =>
      reg.test(firstLetter)
        ? item.firstLetter === "0-9"
        : item.firstLetter === firstLetter
    );
    // console.log(index);
    if (index === -1) {
      firstLettersArray.push({
        id: i++,
        firstLetter: reg.test(firstLetter) ? "0-9" : firstLetter,
        providers: [provider],
      });
      return;
    }
    firstLettersArray[index].providers = [
      ...firstLettersArray[index].providers,
      provider,
    ];
  });
  return firstLettersArray;
};
